import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'idToName'
})
export class IdToNamePipe implements PipeTransform {

  transform(id: number | null | undefined, objectList: any[]): unknown {
    for(let object of objectList){
      if(id == object.id){
        return object.name;
      }
    }
    return null;
  }

}
